module.exports = __webpack_public_path__ + "static/media/test_loading.b4a55673.png";